'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var style = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: 10001
  },
  content: {
    position: 'absolute',
    top: '20%',
    left: '200px',
    right: '40px',
    bottom: '8%',
    border: '1px solid #ccc',
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: '20px 20px 20px'
  }
};

var Popup = function (_Component) {
  _inherits(Popup, _Component);

  function Popup(props) {
    _classCallCheck(this, Popup);

    var _this = _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props));

    _this.state = {
      showModal: false
    };

    _this.handleClosePopup = _this.handleClosePopup.bind(_this);
    _this.handleOpenPopup = _this.handleOpenPopup.bind(_this);
    return _this;
  }

  _createClass(Popup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          insideElement = _props.insideElement,
          closeBtn = _props.closeBtn;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactModal2.default,
          {
            className: 'pda-modal',
            isOpen: this.state.showModal,
            contentLabel: label,
            style: style
          },
          closeBtn,
          insideElement
        )
      );
    }
  }, {
    key: 'handleClosePopup',
    value: function handleClosePopup() {
      this.setState({ showModal: false });
    }
  }, {
    key: 'handleOpenPopup',
    value: function handleOpenPopup() {
      this.setState({ showModal: true });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onRef(this);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.onRef(undefined);
    }
  }]);

  return Popup;
}(_react.Component);

exports.default = Popup;


Popup.propTypes = process.env.NODE_ENV !== "production" ? {
  label: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.object,
  closeTitle: _propTypes2.default.string,
  insideElement: _propTypes2.default.element.isRequired,
  closeBtn: _propTypes2.default.element.isRequired,
  onRef: _propTypes2.default.func.isRequired
} : {};